import {
  Box,
  Button,
  FlexBox,
  Icon,
  ModalDialog,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogNav,
  VisuallyHidden,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Responsible for rendering a magnifying glass icon which pops a "view larger" modal with the provided static image preview / PURCs preview component.
 * */
export const ViewLargerImagesModal = ({
  productName,
  isOpen,
  onZoomButtonClick,
  onDismiss,
  children,
}) => {
  const [orderDetailsMessages, sharedActionMessages] = useTranslations([
    'orderDetailsMessages',
    'sharedActionMessages',
  ]);

  return (
    <>
      {/* Zoom button */}
      <FlexBox alignItems="center" flexDirection="column">
        <Button skin="unstyled" onClick={onZoomButtonClick}>
          <Icon size="standard" iconType="zoomIn" alt="magnifying glass" />
          <VisuallyHidden>
            {orderDetailsMessages.viewLarger}: {productName}
          </VisuallyHidden>
        </Button>
      </FlexBox>
      {/* Product image modal */}
      <ModalDialog
        isOpen={isOpen}
        onRequestDismiss={onDismiss}
        bodyWidth="capped"
        onlyRenderWhenOpen
      >
        <ModalDialogContent style={{ width: '600px' }} aria-label={productName}>
          <ModalDialogNav>
            <ModalDialogCloseButton
              accessibleText={sharedActionMessages.close}
            />
          </ModalDialogNav>
          <ModalDialogBody>
            <Box mt={5} px={6}>
              {children}
            </Box>
          </ModalDialogBody>
          <ModalDialogFooter>
            <ModalDialogButtons>
              <Button
                size="mini"
                width="full-width"
                skin="primary"
                onClick={onDismiss}
              >
                {orderDetailsMessages.close}
              </Button>
            </ModalDialogButtons>
          </ModalDialogFooter>
        </ModalDialogContent>
      </ModalDialog>
    </>
  );
};

ViewLargerImagesModal.propTypes = {
  productName: PropTypes.string,
  isOpen: PropTypes.bool,
  onZoomButtonClick: PropTypes.func,
  onDismiss: PropTypes.func,
  children: PropTypes.any,
};
